// export const baseUrl = "http://18.203.133.130:1337";
// export const baseUrl = "http://192.168.1.33:1337";
//export const baseUrl = "http://18.203.133.130:1337";
export const baseUrl = process.env.REACT_APP_BASE_URL; //Production
export const backendUrl = process.env.REACT_APP_BACKEND_URL;
// export const baseUrl = "http://localhost:1337";
// http://192.168.100.79:1337/api/blogs
// export const baseUrl = "http://192.168.100.51:1337";
export const apiToken = process.env.REACT_APP_API_TOKEN;
